<div [class]="'wrapper ' + customClass" [style]="style">
  <div class="content">
    <span *ngIf="progress !== 1; else Success">{{progress | percent}}</span>
    <ng-template #Success> <mat-icon>check</mat-icon> </ng-template>
  </div>
</div>